import { render, staticRenderFns } from "./TaskDueBar.vue?vue&type=template&id=6d0885f9&scoped=true&"
import script from "./TaskDueBar.vue?vue&type=script&lang=ts&"
export * from "./TaskDueBar.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDueBar.vue?vue&type=style&index=0&id=6d0885f9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0885f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
